import wwiContinueBack from './ContinueBack'
import wwiPageHeader from './PageHeader'

export default {
  wwiContinueBack: wwiContinueBack,
  wwiPageHeader: wwiPageHeader
}
